import { defineComponent as _defineComponent } from 'vue';
import AlarmList from '@blade-sxp/monitoring-center/pages/alarm/components/alarm-list.vue';
import TaskList from '@blade-sxp/monitoring-center/pages/alarm/components/task-list.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        return { __sfc: true, AlarmList, TaskList };
    }
});
